import { gql } from '@apollo/client';
export default gql`
  query getUnPaidSalaryitems(
    $month: Int
    $year: Int
    $departmentId: String
    $employeeId: String
  ) {
    getUnPaidSalaryitems(
      month: $month
      year: $year
      departmentId: $departmentId
      employeeId: $employeeId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        desc
        time
        year
        month
        isPaid
        paymentNo

        basicSalary
        extraSalary
        fullSalary

        bonos
        overtime
        deduction

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
